<template>
  <div id = "home">
    <a href = "https://steamcommunity.com/id/djuczek"><img id = "avatar" src = "../assets/avatar.jpg"/></a>
    <vue-typed-js 
    :strings = "usedStrings"
    :loop = "true" 
    :typeSpeed = "60" 
    :backSpeed = "60"
    :showCursor = "false"
    :backDelay = "3500"
    >
    <h1 class="typing">Shitty Developer</h1>
    </vue-typed-js>
  </div>
</template>

<script>
  export default {
    name: 'home',
    data: function() {
      return {
        usedStrings: [
          'Shitty Developer',
          'Lua Enthuasiast',
          'Firestone-Foundation.pl',
          'Learning PHP, JS'
        ]
      }
    }
  };
</script>

<style lang = "scss" scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');

.typed-element {
  display: flex;
  align-items: center;
  justify-content: center;
  h1 {
    color: #ccc;
    font-family: "Roboto", sans-serif;
    font-size: 32px;
    font-weight: 100;
    border-bottom: 1px solid #ccc;
  }
}

#avatar {
  margin-top: 20vh;
  border-radius: 50%;
  transition: 150ms ease-in-out;
  &:hover {
    transform: scale(1.1);
    box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.5);
  }
}

</style>
